import { ReactNode } from 'react';
import { MicrodataScheme } from '@keaze/web/common/interfaces';

export type AccordionData = {
  name: string;
  description: ReactNode;
  id?: string;
};

export enum AccordionSize {
  Small = 'small',
  Medium = 'medium',
}

export type AccordionProps = {
  data: AccordionData[];
  size?: AccordionSize;
  microdataScheme?: MicrodataScheme;
};
